
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Anycubic() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    document.title = "Anycubic 3D Yazıcı Servisi - Tamir, Bakım, Yedek Parça | Ankara";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da Anycubic 3D yazıcı servisi. Photon, Kobra, Vyper, Mega serisi için profesyonel tamir, bakım ve orijinal yedek parça hizmeti.');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Anycubic 3D Yazıcı Servisi",
      "description": "Ankara'da Anycubic 3D yazıcıları için profesyonel servis hizmeti",
      "brand": {
        "@type": "Brand",
        "name": "Anycubic"
      },
      "provider": {
        "@type": "LocalBusiness",
        "name": "3D Print Pro",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3",
          "addressLocality": "Yenimahalle",
          "addressRegion": "Ankara",
          "postalCode": "06480",
          "addressCountry": "TR"
        },
        "telephone": "+903123945635"
      }
    });
    document.head.appendChild(script);

    return () => {
      try {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      } catch (error) {
        console.warn('Failed to cleanup script:', error);
      }
    };
  }, []);

  const models = [
    { name: "Photon Mono X", type: "Reçine" },
    { name: "Kobra 2 Pro", type: "FDM" },
    { name: "Vyper", type: "FDM" },
    { name: "Mega S", type: "FDM" },
    { name: "Photon Ultra", type: "Reçine" },
    { name: "Kobra Max", type: "FDM" }
  ];

  const services = [
    {
      icon: "ri-tools-line",
      title: "Tamir Hizmeti",
      items: ["Elektronik kart tamiri", "Ekstruder değişimi", "Hotend tamiri", "Leveling sensör tamiri"]
    },
    {
      icon: "ri-settings-3-line",
      title: "Bakım Hizmeti",
      items: ["Düzenli bakım", "Kalibrasyon", "Yazılım güncelleme", "Performans optimizasyonu"]
    },
    {
      icon: "ri-box-3-line",
      title: "Yedek Parça",
      items: ["Orijinal parça tedariki", "Nozzle ve ekstruder", "LCD ekran", "Güç kaynağı"]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="lg:w-1/2">
                <div className="mb-6">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/e62fcc96a129ecb1b3e40cb4fef75d6e.jpg"
                    alt="Anycubic Logo"
                    className="h-20 object-contain"
                  />
                </div>
                <h1 className="text-5xl font-bold text-gray-900 mb-6">
                  Anycubic 3D Yazıcı <span className="text-red-600">Servisi</span>
                </h1>
                <p className="text-xl text-gray-600 mb-8">
                  Ankara'da Anycubic 3D yazıcılarınız için profesyonel tamir, bakım ve yedek parça hizmeti. 
                  Photon, Kobra, Vyper ve Mega serisi tüm modellerde uzman destek.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link 
                    to="/iletisim"
                    className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                  >
                    Randevu Al
                  </Link>
                  <a 
                    href="https://wa.me/903123945635"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                  >
                    WhatsApp
                  </a>
                </div>
              </div>
              <div className="lg:w-1/2">
                <img 
                  src="https://readdy.ai/api/search-image?query=Anycubic%203D%20printer%20professional%20repair%20service%2C%20technician%20working%20on%20Anycubic%20Kobra%20or%20Photon%20printer%2C%20modern%20workshop%20environment%2C%20red%20lighting%20accents%2C%20high-tech%20equipment%20and%20tools&width=600&height=500&seq=anycubic-service&orientation=landscape"
                  alt="Anycubic Servis"
                  className="w-full rounded-xl shadow-2xl object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Models Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Servis Verdiğimiz Anycubic Modelleri
            </h2>
            <p className="text-xl text-gray-600">
              Tüm Anycubic 3D yazıcı modellerinde profesyonel hizmet
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {models.map((model, index) => (
              <div 
                key={index}
                className={`bg-gray-50 rounded-lg p-6 border-2 border-gray-200 hover:border-red-600 transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${200 + index * 50}ms` }}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">{model.name}</h3>
                    <span className="text-sm text-gray-600">{model.type}</span>
                  </div>
                  <i className="ri-checkbox-circle-line text-2xl text-red-600"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Anycubic İçin Hizmetlerimiz
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-red-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <ul className="space-y-3">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-red-600 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Anycubic Yazıcınız Arızalı mı?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Uzman ekibimizle hemen iletişime geçin. Ücretsiz ön değerlendirme ve teklif alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              Randevu Al
            </Link>
            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              WhatsApp ile İletişim
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Markalar</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/markalar" className="hover:text-white transition-colors">Tüm Markalar</Link></li>
                <li><Link to="/markalar/anycubic" className="hover:text-white transition-colors">Anycubic</Link></li>
                <li><Link to="/markalar/creality" className="hover:text-white transition-colors">Creality</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0312 394 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
